<template>
  <div :id="id" class="modal">
    <div class="modal__content">
      <div class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200 dark:border-dark-5">
        <h2 class="font-medium text-base mr-auto">{{ title }}</h2>
      </div>
      <div>
        <slot></slot>
      </div>
      <div
        class="px-5 py-3 flex items-center justify-between border-t border-gray-200 dark:border-dark-5"
      >
        <Button
          type="button"
          @click="onCancel"
          class="w-20 border text-gray-700 dark:border-dark-5 dark:text-gray-300 mr-1"
        >
          {{ $t('text.cancel') }}
        </Button>
        <Button
          v-if="!noSaveButton"
          type="button"
          @click="onSubmit"
          :loading="loading"
          class="w-32 bg-theme-1 text-white"
        >
          {{ $t('text.save') }}
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@/components/ui/button/Button';

export default {
  name: 'ModalEdit',

  components: { Button },

  props: {
    id: {
      type: String,
      default: 'edit-modal',
    },
    title: String,
    loading: Boolean,
    noSaveButton: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    onCancel() {
      cash(`#${this.id}`).modal('hide');
      this.$emit('onClickCancel');
    },

    onSubmit() {
      this.$emit('click');
    },
  },
};
</script>
